const initState = {
    requiresAction: false,
    stripeSetupIntent: "",
    stripePaymentIntent: "",

    isPaymentMethodActing: false,
    isPaymentMethodActed: false,
    paymentMessage: "",

    isBuyProdActing: false,
    isBuyProdActed: false,
    buyProdActMessage: "",
}

const paymentReducer = (state = initState, action) => {
    // SECTION 1
    if (action.type === "OPEN_STRIPE_PM_ACT") {
        return {
            ...state,
            isPaymentMethodActing: false,
            isPaymentMethodActed: false,
            paymentMessage: action.paymentMessage,
            stripeSetupIntent: action.stripeSetupIntent,
        }
    }
    else if (action.type === "STRIPE_PM_ACTING") {
        return {
            ...state,
            isPaymentMethodActing: true,
            isPaymentMethodActed: false,
            paymentMessage: "",
        }
    }
    else if (action.type === "STRIPE_PM_ACTED") {
        return {
            ...state,
            isPaymentMethodActing: false,
            isPaymentMethodActed: true,
            paymentMessage: action.paymentMessage,
        }
    }
    else if (action.type === "STRIPE_PM_ACT_FAILED") {
        return {
            ...state,
            isPaymentMethodActing: false,
            isPaymentMethodActed: false,
            paymentMessage: action.paymentMessage,
        }
    }

    // SECTION 2
    else if (action.type === "OPEN_STRIPE_PROD_ACT") {
        return {
            ...state,
            isBuyProdActing: false,
            isBuyProdActed: false,
            buyProdActMessage: action.buyProdActMessage,
            stripePaymentIntent: action.stripePaymentIntent,
        }
    }
    else if (action.type === "STRIPE_PROD_ACTING") {
        return {
            ...state,
            isBuyProdActing: true,
            isBuyProdActed: false,
            buyProdActMessage: "",
        }
    }
    else if (action.type === "STRIPE_PROD_ACTED") {
        return {
            ...state,
            isBuyProdActing: false,
            isBuyProdActed: true,
            buyProdActMessage: action.buyProdActMessage,
            stripePaymentIntent: action.stripePaymentIntent,
        }
    }
    else if (action.type === "STRIPE_PROD_ACT_FAILED") {
        return {
            ...state,
            isBuyProdActing: false,
            isBuyProdActed: false,
            buyProdActMessage: action.buyProdActMessage,
            stripePaymentIntent: action.stripePaymentIntent,
        }
    }
    else if (action.type === "REFRESH_STRIPE_PROD_ACT") {
        return {
            ...state,
            isBuyProdActing: false,
            isBuyProdActed: false,
        }
    }

    return state;
}



export default paymentReducer;